import React, {useEffect, useState} from 'react';
import {JSON_HEADERS} from "../../constants/constants";
import {useForm} from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
// import Redactor
import '../../../../../vendor/assets/stylesheets/redactor.min.css'
import {Redactor} from "../../../../../vendor/assets/javascripts/redactor";
import {sanitizeRedactorContent} from "../../utils/postingHelpers";

export default function ReplyUpdate(props) {

    let {
        reply,
        currentUser,
        token
    } = props;

    // Also in props: onReplyUpdate, onReplyUpdateCancel

    const cta = 'Save';
    const [btnCta, setBtnCta] = useState(cta);
    const { register, handleSubmit, setValue, clearErrors, reset, formState: { errors, isSubmitting }} = useForm();

    const userSignedIn = !!currentUser;
    const adminUser = userSignedIn && currentUser.admin;

    const onReplySave = async(data) => {
        setBtnCta('Saving...');

        await fetch(`/replies/${reply.id}`, {
            method: 'PATCH',
            headers: JSON_HEADERS,
            body: JSON.stringify(data)
        });

        onReplyReset();
        props.onReplyUpdate(data.reply);
    }

    const onReplyReset = () => {
        setBtnCta(cta);
        reset();
        clearErrors('reply.body');
        props.onReplyUpdateCancel();
    }

    useEffect(() => {
        if (userSignedIn) {
            Redactor(`#body-r${reply.id}`, { toolbar: false, focusEnd: true, callbacks: {
                    blur: function(e) {
                        // set textarea value for react-hook-form
                        let html = sanitizeRedactorContent(this.source.getCode());
                        setValue('reply.body', html);
                    }}
            });
        }
    }, []);

    return (
        <Form
            noValidate={true}
            acceptCharset='UTF-8'
            onSubmit={handleSubmit(onReplySave)}
        >
            <input type='hidden' id='authenticity_token' key='authenticity_token' value={token} {...register('authenticity_token')} />

            <Form.Group>
                <Form.Control
                    as={'textarea'}
                    id={`body-r${reply.id}`}
                    defaultValue={reply.body}
                    {...register("reply.body", { required: 'This field is required' })} />
            </Form.Group>

            <div className={'d-flex flex-wrap flex-sm-nowrap mt-3'}>
                {errors.reply?.body && <Form.Text className="text-danger">{errors.reply.body.message}</Form.Text>}
                <Button variant="light" className={'me-0 me-sm-2 my-2 my-sm-0 ms-sm-auto'} onClick={() => onReplyReset()} id={`cancel_${reply.id}`}>
                    Cancel
                </Button>
                <Button variant="primary" type="submit" className={'btn-hover-cursor'} disabled={isSubmitting} id={`save_${reply.id}`}>
                    {btnCta}
                </Button>
            </div>
        </Form>
    )
}